import { Button, makeStyles } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles({
    btn: {
        color: 'white',
        backgroundColor: '#1D8BF7',
        '&:hover': {
            backgroundColor: '#1D8BF7',
        },
    },
});
interface IProps {
    onClick?: () => void;
}

export function AlertMessage({ onClick }: IProps) {
    const { t } = useTranslation();
    const { btn } = useStyles();

    return (
        <div>
            <p>
                <Trans i18nKey="OverviewPage.alert.infoText">
                    0 <strong>1</strong> 2
                </Trans>
            </p>
            <Button className={btn} onClick={onClick && onClick} color="primary" endIcon={<ChevronRightIcon />}>
                {t('OverviewPage.alert.btn')}
            </Button>
        </div>
    );
}
